export type PricingFeature = {
  label: string;
  tag?: string;
  inCollaborateur?: boolean;
};

export const PRICING_PLANS = [
  {
    id: 'cabinet',
    price: 49,
  },
  {
    id: 'collaborateur',
    price: 17,
    description:
      'Vous travaillez dans un cabinet équipé de zLawyer ? Accédez à votre propre licence personnelle à tarif préférentiel.',
  },
] as const;

export type PricingPlanId = (typeof PRICING_PLANS)[number]['id'];

export type ComparisonRow = {
  feature: string;
  cabinetValue: string;
  collabValue: string;
  cabinetPositive: boolean;
  collabPositive: boolean | 'partial';
};

export const PRICING_COMPARISON: ComparisonRow[] = [
  {
    feature: 'Gestion des dossiers',
    cabinetValue: 'Complète',
    collabValue: 'Dossiers personnels',
    cabinetPositive: true,
    collabPositive: true,
  },
  {
    feature: 'Facturation',
    cabinetValue: 'Avancée',
    collabValue: 'Facturation au cabinet',
    cabinetPositive: true,
    collabPositive: true,
  },
  {
    feature: 'Facturation électronique',
    cabinetValue: 'Incluse',
    collabValue: 'Incluse',
    cabinetPositive: true,
    collabPositive: true,
  },
  {
    feature: 'Suivi du temps',
    cabinetValue: 'Complet',
    collabValue: 'Simplifié',
    cabinetPositive: true,
    collabPositive: true,
  },
  {
    feature: 'Pilotage rentabilité',
    cabinetValue: 'Oui',
    collabValue: 'Non',
    cabinetPositive: true,
    collabPositive: false,
  },
  {
    feature: 'Intégration Pennylane',
    cabinetValue: 'Oui',
    collabValue: 'Via le cabinet',
    cabinetPositive: true,
    collabPositive: 'partial',
  },
  {
    feature: 'Support',
    cabinetValue: 'Dédié',
    collabValue: 'Standard',
    cabinetPositive: true,
    collabPositive: true,
  },
  {
    feature: 'Accès cabinet',
    cabinetValue: 'Centralisé',
    collabValue: 'Connecté au cabinet',
    cabinetPositive: true,
    collabPositive: 'partial',
  },
];

export const CABINET_PLAN_FEATURES = [
  'Gestion complète des dossiers',
  'Facturation avancée',
  'Facturation électronique conforme 2026',
  'Suivi précis du temps',
  'Analyse de rentabilité',
  'Reporting et tableaux de bord',
  'Intégration Pennylane',
  'Support dédié',
];

export const COLLAB_PLAN_FEATURES = [
  'Gestion des dossiers personnels',
  'Facturation au cabinet',
  'Facturation électronique incluse',
  "Suivi simplifié de l'activité",
  'Collaboration fluide avec le cabinet',
];

export type FeatureGroup = {
  id: string;
  label: string;
  collabBadge?: boolean;
  features: PricingFeature[];
};

export const PRICING_FEATURES: PricingFeature[] = [
  // Cabinet uniquement — 12 features (6 rangées pleines dans la grille 2 colonnes)
  { label: 'Tableau de bord (MYzLawyer)' },
  { label: 'Gestion des profils utilisateurs' },
  { label: 'Gestions des dossiers' },
  { label: 'Gestion documentaire' },
  { label: 'Modèles personnalisables' },
  { label: 'Gestion des emails' },
  { label: 'Suivi des performances' },
  { label: 'Exports comptables' },
  { label: 'Rapprochement bancaire' },
  { label: 'Tamponnage numérique' },
  { label: 'Intelligence artificielle Zephyr' },
  { label: 'LCB-FT' },
  // Inclus dans les deux formules — 7 features
  { label: 'Facturation électronique', inCollaborateur: true },
  { label: 'Facturation au temps passé / forfait / provisions', inCollaborateur: true },
  { label: 'Suivi du reste à facturer par dossier', inCollaborateur: true },
  { label: 'Tableaux de bords financiers', inCollaborateur: true },
  { label: 'Reportings et statistiques', inCollaborateur: true },
  { label: 'Relance des impayes', inCollaborateur: true },
  { label: 'Application mobile', inCollaborateur: true },
];

export const PRICING_FEATURE_GROUPS: FeatureGroup[] = [
  {
    id: 'gestion',
    label: 'Gestion du cabinet',
    features: PRICING_FEATURES.slice(0, 4),
  },
  {
    id: 'productivite',
    label: 'Productivité & Communication',
    features: PRICING_FEATURES.slice(4, 8),
  },
  {
    id: 'pilotage',
    label: 'Pilotage & Conformité',
    features: PRICING_FEATURES.slice(8, 12),
  },
  {
    id: 'facturation',
    label: 'Facturation',
    collabBadge: true,
    features: PRICING_FEATURES.slice(12),
  },
];
